// routes
import { PATH_Admin } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// ----------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_chart'),
    dataMapping: icon('ic_mapping'),
    noneligibleRecords: icon('ic_noneligible'),
    enablereupload: icon('ic_reupload'),
    topic: icon('ic_topic'),
    cart: icon('category'),
    helpdesk: icon('ic_helpdesk'),
    menus: icon('ic_menus'),
    tags: icon('tag')
};

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [

            { title: 'Help Topics', path: PATH_Admin.helptopics, icon: ICONS.topic },
            // { title: 'Help Menus', path: PATH_Admin.helpmenus, icon: ICONS.menus },
            { title: 'Help Category', path: PATH_Admin.helpcategory, icon: ICONS.cart },
            { title: 'Sub Category', path: PATH_Admin.subcategory, icon: ICONS.enablereupload },
            { title: 'Tags', path: PATH_Admin.tags, icon: ICONS.tags },

        ],
    }
];
export default navConfig;